import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.contest.official')

export const handle = {
  name: 'contest-official',
  track: { scene: 'contest' },
  showAppNav: true,
}

export function loader() {
  return null
}

export default dynamic(getClientModule, { ssr: false })
